<template>
  <div class="image-ad_slider" :style="style">
    <van-swipe :autoplay="3000" @change="v=>current=v">
      <van-swipe-item v-for="item in config.sub_entry" :key="item.key">
        <component :is="tagName" :href="item.link_url" class="swipe-item_image">
          <van-image :src="item.image_url"
                     :style="imgStyle"
                     :fit="config.image_fill_style===0?'cover':'contain'"/>
          <div class="link-title" v-if="item.title">{{item.title}}</div>
        </component>
      </van-swipe-item>
      <template #indicator>
        <div class="text-indicator" v-if="config.indicator===0">
          {{current+1 +"/"+ config.sub_entry.length}}
        </div>
        <div class="dot-indicator" :class="config.indicator===1?'long-dot':''" v-else>
                    <span class="dot-item" :class="i===current?'dot-indicator_active':''"
                          v-for="(it, i) in config.sub_entry" :key="it.key"></span>
        </div>
      </template>
    </van-swipe>
  </div>
</template>

<script>
  export default {
	name: "Slider",
	components: {},
	props: {
	  config: Object
	},
	data() {
	  return {
		current: 0
	  };
	},
	created() {
	},
	methods: {},
	computed: {
	  tagName() {
		return this.$IS_PREVIEW ? 'div' : 'a';
	  },
	  style() {
		const [first] = this.config.sub_entry;
		if (!first) return '';
		const width = this.$clientWidth - this.config.page_margin;
		const height = (first.image_height / first.image_width) * width;

		return {
		  height: height + 'px',
		  borderRadius: this.config.corner_type ? "10px" : "",
		  boxShadow: this.config.image_style ? "0 4px 10px rgba(47,54,70,0.1)" : ""
		};
	  },
	  imgStyle() {
		if (!this.style) return;
		return {
		  height: this.style.height,
		  width: '100%'
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .image-ad_slider {
    overflow: hidden;

    .van-swipe, .van-swipe-item {
      height: 100%;
    }

    .swipe-item_image {
      display: block;
    }

    .van-image {
      display: block;
      height: 100%;
    }

    .text-indicator {
      position: absolute;
      bottom: 5px;
      right: 10px;
      border-radius: 10px;
      line-height: 20px;
      padding: 0 10px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
    }

    .dot-indicator {
      position: absolute;
      bottom: 10px;
      right: 0;
      left: 0;

      display: flex;
      justify-content: center;

      &.long-dot {
        .dot-item {
          width: 18px;
          height: 8px;
          border-radius: 4px;
        }
      }

      .dot-item {
        height: 10px;
        width: 10px;
        margin: 0 5px;
        background-color: #C0C4CC;
        border-radius: 5px;


        &.dot-indicator_active {
          background-color: #ff6400;
        }
      }

    }
  }
</style>
